import cx from 'classnames'
import { forwardRef } from 'react'
import { TabProps } from './Types'
import { useObjectRef } from '@react-aria/utils'
import Styles from './Tabs.module.scss'
import { useHover } from '@react-aria/interactions'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'

export const Tab = forwardRef<HTMLDivElement, TabProps>(
  ({ icon: Icon, label, isActive = false, withDot = false, onPress, tourId, isCompact = false }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps, isPressed, ...rest } = useButtonWithScrollCancel({ onPress, elementType: 'div' }, ref)
    const { hoverProps, isHovered } = useHover({})

    return (
      <div
        {...buttonProps}
        {...rest}
        {...hoverProps}
        className={cx(Styles.tab, tourId, {
          [Styles.compact]: isCompact,
          [Styles.active]: isActive,
          [Styles.hovered]: isHovered,
          [Styles.pressed]: isPressed,
        })}
        ref={ref}
      >
        <Icon />
        <div className={Styles.tabLabel}>{label}</div>
        {withDot && <div className={Styles.tabDot} />}
      </div>
    )
  },
)
